import React, { Component } from 'react';
import withRouter from 'utils/withRouter';
import AuthService from 'services/cognito/lib';

class CallbackComponent extends Component<{ router: any }> {
    async componentDidMount() {
        const tokens = await AuthService.getAuthTokens();
        AuthService.setSession(tokens);
        return this.props.router.navigate('/');
    }

    render() {
        return <p>Loading permissions...</p>;
    }
}

export default withRouter(CallbackComponent);
